export default "__VITE_ASSET__DDGilFbE__"